import React from "react";
import styled from "styled-components";
import { Button } from "@material-ui/core";
import FacebookIcon from "mdi-react/FacebookIcon";
import GoogleIcon from "mdi-react/GoogleIcon";

export const SocialButton = styled(Button).attrs({
  variant: "contained"
})`
  && {
    color: white;
    text-transform: capitalize;
    font-size: 12px;
    width: 150px;
    border-radius: 0;
    @media (max-width: 380px) {
      width: 110px;
    }
  }
`;

const SocialButtonText = styled.span`
  margin-top: 3px;
  margin-left: 10px;
`;

export const Fbb = styled(SocialButton)`
  && {
    background: #3b5a96;
    &:hover {
      background-color: #273b63;
    }
  }
`;

export const Gb = styled(SocialButton)`
  && {
    background-color: #da4a3f;
    &:hover {
      background-color: #c12f25;
    }
  }
`;

export function FacebookButton(props) {
  return (
    <Fbb {...props}>
      <FacebookIcon size={14} />
      <SocialButtonText>Facebook</SocialButtonText>
    </Fbb>
  );
}

export function GoogleButton(props) {
  return (
    <Gb {...props}>
      <GoogleIcon size={14} />
      <SocialButtonText>Google</SocialButtonText>
    </Gb>
  );
}
